export default {"src":"/_next/static/media/reactjs-icon.67f88695.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};